<div class="db-informative-banner">
  <div class="db-content">
    <h1 [innerHTML]="title" class="db-informative-banner__title"></h1>
    <p class="db-informative-banner__desc" [innerHTML]="description"></p>
  </div>
    <div>
      <a class="ds-btn-blue ds-btn-m" [style.width]="subscription?.trialClient && !demoUser && '146px'"
         (click)="onBtnClick()">
        @if (subscription?.trialClient && !demoUser) {
          <i class="db-icon db-icon-ds-diamond-new mr8"></i>
        }
        <span [innerHTML]="subscription?.trialClient ? demoUser ?  ('text_informativeBtnText' | dbText)
        : ('text_upgrade' | dbText) : ('text_enableNow' | dbText)"></span>
      </a>
    </div>
</div>
